import React from 'react'
import { Translator } from '@morningtrain/react-translations'
import AdminPage from 'pages/app/AdminPage'
import { WhenRouteHasParameter } from '@morningtrain/react-navigation'
import DepartmentSupplierEditForm from 'pages/app/settings/department_suppliers/partials/DepartmentSupplierEditForm'

export default function DepartmentsEdit () {
  return (
    <AdminPage>
      <WhenRouteHasParameter name='department_supplier'>
        <Translator namespace='settings.department_suppliers'>
          <DepartmentSupplierEditForm create={false} />
        </Translator>
      </WhenRouteHasParameter>
      <WhenRouteHasParameter name='department_supplier' negate>
        <Translator namespace='settings.department_suppliers'>
          <DepartmentSupplierEditForm create />
        </Translator>
      </WhenRouteHasParameter>
    </AdminPage>
  )
}
